import { render, staticRenderFns } from "./DuplicateDeliverableTemplateBtn.vue?vue&type=template&id=b5f0fadc&"
import script from "./DuplicateDeliverableTemplateBtn.vue?vue&type=script&lang=js&"
export * from "./DuplicateDeliverableTemplateBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports